import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { OnChanges } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { TagColor } from '@freelancer/ui/tag';
import { ChallengeStatusTagType } from './challenge-status-tag.types';

@Component({
  selector: 'fl-challenge-status-tag',
  standalone: true,
  imports: [UiModule, CommonModule],
  template: `
    <fl-tag
      class="Tag"
      [color]="tagColor"
    >
      <ng-container [ngSwitch]="status">
        <ng-container
          *ngSwitchCase="ChallengeStatusTagType.DRAFT"
          i18n="Challenge draft status tag"
        >
          Draft
        </ng-container>
        <ng-container
          *ngSwitchCase="ChallengeStatusTagType.OPEN"
          i18n="Challenge open status tag"
        >
          Open
        </ng-container>
        <ng-container
          *ngSwitchCase="ChallengeStatusTagType.COMING_SOON"
          i18n="Challenge coming soon status tag"
        >
          Coming Soon
        </ng-container>
        <ng-container
          *ngSwitchCase="ChallengeStatusTagType.CLOSED"
          i18n="Challenge closed status tag"
        >
          Closed
        </ng-container>
      </ng-container>
    </fl-tag>
  `,
  styleUrls: ['./challenge-status-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeStatusTagComponent implements OnChanges {
  ChallengeStatusTagType = ChallengeStatusTagType;

  tagColor: TagColor;
  @Input({ required: true }) status: ChallengeStatusTagType;

  ngOnChanges(): void {
    switch (this.status) {
      case ChallengeStatusTagType.OPEN:
        this.tagColor = TagColor.SUCCESS_LIGHT;
        break;
      case ChallengeStatusTagType.COMING_SOON:
        this.tagColor = TagColor.YELLOW_LIGHT;
        break;
      case ChallengeStatusTagType.CLOSED:
        this.tagColor = TagColor.SECONDARY_DARK;
        break;
      case ChallengeStatusTagType.DRAFT:
        this.tagColor = TagColor.DANGER;
        break;
      default:
    }
  }
}
